import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './styles/Banners.module.scss';

import { OmaLummeApp } from '../../../omaLummeContext';

import Button from '../../Common/Button';

// Utils.
import { contractIsEnergyManagement } from '../../Contracts/ManageContracts/EnergyManagement';

const EnergyManagementBanner: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { contracts, selectedMeteringPointContract } = OmaLummeApp.useState();

  const [showBanner, setShowBanner] = React.useState<boolean>(localStorage.getItem('EnergyManagementBannerDisplayed') !== 'true');

  return (
    <>
      {((contracts && contracts.filter((c) => contractIsEnergyManagement(c)).length > 0) ||
        (selectedMeteringPointContract && contractIsEnergyManagement(selectedMeteringPointContract))) &&
        showBanner && (
          <>
            <div className={`${styles.greenBanner}`}>
              <div>
                <button
                  className={styles.dismiss}
                  onClick={() => {
                    setShowBanner(false);
                    window.localStorage.setItem('EnergyManagementBannerDisplayed', 'true');
                  }}
                >
                  <span>{t(`common:general.close`)}</span>
                </button>
                <h2 className="h1">{t(`landingPage:energyManagementBanner.title`)}</h2>

                <p>{t(`landingPage:energyManagementBanner.description`)}</p>

                <Button className="buttonTertiaryTurquoise" link="/energyManagement">
                  {t(`landingPage:energyManagementBanner.cta`)}
                </Button>
              </div>
            </div>
          </>
        )}
    </>
  );
};

export default EnergyManagementBanner;
